<template>
    <div class="mt-3">
        <h5>Your download should start momentarily. Once the file has finished downloading and you have saved it to your computer please confirm receipt by clicking the button below.</h5>
        <button class="btn btn-primary mt-3" @click="confirm()">Confirm Receipt</button>
    </div>    
</template>

<script>
export default {
    props: {
        downloadUrl: String,
        confirmationUrl: String,
        signature: String
    },
    methods: {
        confirm: function () {
            axios.get(this.confirmationUrl)
                .then(response => {
                    window.location = response.data.url;
                })
                .catch(error => {
                    window.location = error.response.data;
                });
        }        
    },
    mounted() {

        // zip file we can stay on this page
        window.location = this.downloadUrl;     
    }   
}
</script>

<style scoped>

</style>